import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Modal, Row, Col} from 'react-bootstrap';
import AddStudentsForm from './AddStudentsForm';
import * as groupActions from '../../actions/groupActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import label from '../../utils/lngEn';

class AddStudentsModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      name: {
        value: '', style: null, message: ''
      },
      group: {
        title: '',
        groupId: '',
        initialValues: {
        }
      }
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.getStudents = this.getStudents.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({group: nextProps.initial});
  }

  handleSubmit (values) {
    this.props.groupActions.addStudentsToGroup(this.props.group.id, values.students)
      .then(() => {

        this.props.groupActions.getGroupById(this.props.group.id)
          .then(() => {
            this.props.studentActions.getAllStudents();
            this.props.groupActions.getAllGroups();
          });
        this.props.closeModal();
      });

  }

  getStudents = () => {
    let newStudents = Object.assign([], this.props.students);
    let studentsOjbs = [];
    this.props.group.memberships.map(membership => {
      newStudents.map((s,index) => {
        if(s.id == membership.student) {
          delete newStudents[index];
        }
      });
    });
    newStudents.map(student => {
      studentsOjbs.push({
        id: student.id,
        email: student.user.email
      })
    });
    return studentsOjbs;
  }

  render(){
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static" className="addConflictModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {this.state.group.title || label.addStudentToGroup}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{label.addStudentModalBody}</p>
          <AddStudentsForm
            onSubmit={this.handleSubmit}
            onCancel={this.props.onCancel}
            studentsArray={this.getStudents()}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    students: state.students,
    student: state.student, //delete
    group: state.group
  };
}

function mapDispatchToProps(dispatch) {
  return {
    groupActions: bindActionCreators(groupActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddStudentsModal);



// WEBPACK FOOTER //
// ./src/components/groups/AddStudentsModal.js